import { type CustomTooltipProps } from "ag-grid-react"

import { Card, CardContent, CardHeader, CardTitle } from "~/components/reusable/Card"
import InventoryValueGraph from "~/components/reusable/graphs/InventoryValueGraph"

import HeaderTooltip from "./HeaderTooltip"

const InventoryValueGraphTooltip = (props: CustomTooltipProps) => {
  // Show when the location is the header
  if (props.location === "header") {
    return <HeaderTooltip {...props} />
  }
  // props.data / props.value can be undefined for not-yet-hydrated or mismatched rows.
  const variantIds: string[] = props.node?.group
    ? (props.value ?? [])
    : props.data?.variantId
      ? [props.data.variantId]
      : []
  if (variantIds.length === 0) return null
  // SKU leaf rows narrow the graph to that SKU; variant rows show the whole variant.
  const skuIds =
    !props.node?.group && typeof props.data?.skuId === "string" ? [props.data.skuId] : undefined
  return (
    <Card className="w-[400px]">
      <CardHeader>
        <CardTitle>Inventory value</CardTitle>
      </CardHeader>
      <CardContent>
        <InventoryValueGraph variantIds={variantIds} skuIds={skuIds} />
      </CardContent>
    </Card>
  )
}

export default InventoryValueGraphTooltip
